// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-play-btn {
  border: none;
  background: transparent;
}
.video-play-btn:focus {
  outline: none;
}

.close {
  font-size: 25px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/pages/guidelines/sections/youtubeModal.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,uBAAA;AACF;AACE;EACE,aAAA;AACJ;;AAGA;EACE,eAAA;AAAF","sourcesContent":[".video-play-btn {\r\n  border: none;\r\n  background: transparent;\r\n\r\n  &:focus {\r\n    outline: none;\r\n  }\r\n}\r\n\r\n.close{\r\n  font-size: 25px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
